/** True when the string is a finite number greater than zero (floats allowed). */
export const isPositiveNumber = (value: string): boolean => {
  if (value.trim() === '') return false;
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
};
